// extracted by mini-css-extract-plugin
export default {"container":"MobileMessage_container--CwY","message":"MobileMessage_message--GWO","tailMessage":"MobileMessage_tailMessage--KGg"};